import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = {
  isLoading: false,
  apiError: null,
};

const fetchReactivateReducer = state => ({
  ...state,
  isLoading: true,
  apiError: null,
});

const reactivateSuccessReducer = state => ({
  ...state,
  isLoading: false,
});

const reactivateFailureReducer = (state, { payload }) => ({
  ...state,
  isLoading: false,
  apiError: payload.message,
});

export default createReducer(initialState, {
  [actionTypes.REACTIVATE_LOCKER_REQUEST]: fetchReactivateReducer,
  [actionTypes.REACTIVATE_LOCKER_SUCCESS]: reactivateSuccessReducer,
  [actionTypes.REACTIVATE_LOCKER_FAILURE]: reactivateFailureReducer,
});
